import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    Output,
    ViewChild,
} from '@angular/core';
import { CustomUserClaims, UserClaims } from '@okta/okta-auth-js';
import { EMPTY, Subscription } from 'rxjs';

import { ProfileRoutes } from './interfaces/profile-routes.interface';

@Component({
    selector: 'mapp-dropdown-profile',
    templateUrl: './dropdown-profile.component.html',
    styleUrls: ['./dropdown-profile.component.scss'],
    standalone: false,
})
export class DrowpdownProfileComponent implements OnDestroy {
    public ProfileRoutes = ProfileRoutes;

    @Input() initialText: string;

    @Input() userData: UserClaims<CustomUserClaims>;

    @Input() dropdownPosition: string;

    @Output() logout = new EventEmitter<void>();

    showItems = false;

    routerSubscription: Subscription = EMPTY.subscribe();

    @ViewChild('profileDropdown') profileDropdown!: ElementRef;

    /**
     *
     */
    toggleItems() {
        this.showItems = !this.showItems;
    }

    /**
     *
     * @param event
     */
    @HostListener('document:click', ['$event'])
    /**
     * Handles the document click event to determine if the click occurred inside the profile dropdown.
     * If the click is outside the dropdown, it hides the dropdown items.
     * @param event - The mouse event triggered by the document click.
     */
    onDocumentClick(event: MouseEvent) {
        const clickedInside = this.profileDropdown?.nativeElement.contains(event.target);
        if (!clickedInside) {
            this.showItems = false;
        }
    }

    /**
     *
     */
    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
    }
}
